(function ($) {
	$.heroRotator = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			HeroRotator = (function ($c, o) {
				var defaults = {
					'heroSelector': '.module-image-hero__background',
					'itemSelector': '.module-image-hero__image',
					'activeClass': 'active',

					'slideTime': 30000
				}; 

				var _o = {},
					$hero = null,
					$items = null,
					$nav = null,

					ci = 0, // Current Index
					clock = 0
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$hero = $(_o.heroSelector, $c);
					$items = $(_o.itemSelector, $hero);
				},

				_BindEvents = function () {
					_StartClock();
				},

					_StartClock = function() {
						clearTimeout(clock);
						clock = setTimeout(function() {
							_OnClock();
						}, _o.slideTime);
					},

					_OnClock = function() {
						var ni = (ci + 1) % $items.length;

						_SetCurrentSlide(ni);
						_StartClock();
					},

					_SetCurrentSlide = function(index) {
						$items.removeClass(_o.activeClass);
						$items.eq(index).addClass(_o.activeClass);

						ci = index;
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.heroRotator = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('heroRotator')) {
				var plugin = new $.heroRotator(this, options);
				$(this).data('heroRotator', plugin);
			}
		});
	};
})(jQuery);
